export default __webpack_public_path__ + "static/media/Shifters.832c3b16.png";